import { render, staticRenderFns } from "./CalendarMonthly.vue?vue&type=template&id=3975380a"
import script from "./CalendarMonthly.vue?vue&type=script&lang=js"
export * from "./CalendarMonthly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports